<template>
    <div class="form-element__container" id="title-container">
        <select
            :class="[{ 'form-element__input--active': title !== '' }, {'placeholder': !title}]"
            class="form-element__input form-element__input--title select"
            name="title"
            :id="fullFormIdentifier"
            v-model="title"
            data-validate="select"
            data-validate-message="Please select your title"
            :readonly="readonly"
        >
            <option value="" disabled selected hidden  class="placeholder-option">Title*</option>
            <option v-for="option in titles" :key="option" :value="option">{{ option }}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: {
        formIdentifier: {
            type: String,
            default: "form",
        },
        readonly:{
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            titles: ["Mr.", "Mrs.", "Miss", "Dr.", "Ms.", "Prof."],
        };
    },
    computed: {
        title: {
            get: function () {
                return this.$store.state.CustomerData.title;
            },
            set: function (newValue) {
                this.$store.dispatch("CustomerData/storeCustomerData", { title: newValue });
            },
        },
        fullFormIdentifier() {
            return this.formIdentifier + "-" + this._uid;
        },
    },
};
</script>

<style lang="scss" scoped>
  .placeholder {
    color:#757575;
  }
// .title__select {
//     border-radius: 6px;
//     padding: 10px;
//     width: 130px;
//     border: none;
//     background-color: #f7f7f7;

//     &:focus {
//         border: 1px solid #0093d6;
//         background-color: #ecf9ff;
//     }
// }

// .active {
//     border: 1px solid #0093d6;
//     background-color: #ecf9ff;
//     color: #0093d6;
// }
</style>
